import { render, staticRenderFns } from "./list.vue?vue&type=template&id=db4b3934&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=db4b3934&prod&scoped=true&lang=css"
import style1 from "./list.vue?vue&type=style&index=1&id=db4b3934&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4b3934",
  null
  
)

export default component.exports